export default __webpack_public_path__ + "static/media/1_2x2.181f07a3.jpg";